import SelectUmUiLayoutTypeDialog from '@/pages/MainPage/dialogs/SelectUmUiLayoutTypeDialog'
import InputModalSelect from '../components/InputModalSelect.jsx'

export default function SelectUiLayoutType({value, ...props}) {
    const getText = multiple => multiple ?
        (value ?? []).map(({layoutTypeName}) => layoutTypeName).join(',') :
        (value ?? {}).layoutTypeName

    return (
        <InputModalSelect
            getText={getText}
            Modal={SelectUmUiLayoutTypeDialog}
            {...props}
        />
    )
}
